import { apiClient, ApiName } from '@shared/services/api'

export const fetchHolidays = (config) => {
  return apiClient.get(ApiName.ADMINS, 'holidays', config)
}

export const createHoliday = (data) => {
  return apiClient.post(ApiName.ADMINS, 'holidays', data)
}

export const deleteHoliday = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'holidays', id)
}
